/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Nucleus Admin API
 * Headless, multi-tenant commerce backend for jewelry brands.
 *
 * ## Surfaces
 *
 * | Prefix | Caller | Credential |
 * |---|---|---|
 * | `/platform/v1` | Platform operator | Platform token from **Platform: Auth** |
 * | `/admin/v1` | Staff of one organization | Staff token from **Admin: Auth** |
 * | `/storefront/v1` | A storefront | Store API key from **Admin: API keys** |
 * | `/public/v1` | Anyone (the brand application form) | None; rate limited per IP |
 *
 * Every credential is sent as `Authorization: Bearer <value>`. Use the **Authorize** button once and it applies to every request you try here.
 *
 * ## Conventions
 *
 * - **Ids** are UUID v7 strings. **Timestamps** are ISO 8601 in UTC. **Money** is `{ amount, currency }` with `amount` in integer minor units.
 * - **Lists** paginate by cursor: `?limit=20&cursor=...` in, `{ items, nextCursor }` out, `nextCursor` is `null` on the last page.
 * - **Errors** always use one envelope, `{ error: { code, message, requestId, details?, meta? } }`. Switch on `code`, never on `message`.
 * - **Request ids**: every response carries `x-request-id`. Quote it when reporting a problem.
 * - **Idempotency**: endpoints that create money-related state require an `Idempotency-Key` header; the header is listed on those endpoints.
 * - A record that belongs to another tenant answers **404**, never 403, so existence is not leaked.
 * OpenAPI spec version: 0.1.0
 */

export type SeoIssueCode = typeof SeoIssueCode[keyof typeof SeoIssueCode];


export const SeoIssueCode = {
  title_missing: 'title_missing',
  title_too_long: 'title_too_long',
  description_missing: 'description_missing',
  description_too_long: 'description_too_long',
  duplicate_title: 'duplicate_title',
  duplicate_description: 'duplicate_description',
  image_alt_missing: 'image_alt_missing',
  thin_description: 'thin_description',
  jsonld_invalid: 'jsonld_invalid',
  offer_missing_shipping: 'offer_missing_shipping',
  redirect_chain: 'redirect_chain',
  redirect_loop: 'redirect_loop',
  redirect_to_404: 'redirect_to_404',
  orphan_product: 'orphan_product',
} as const;
